var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"priceshow",style:({ fontSize: _vm.priceSize + 'px', color: _vm.color }),attrs:{"ar":_vm.$i18n.locale === 'ar'}},[_c('em',{style:({ fontSize: _vm.markSize + 'px', fontFamily: _vm.markBold ? 'bold' : 'Source Han Sans CN' })},[_vm._v(" "+_vm._s(_vm.$store.state.currentCurrency?.tittle))]),_vm._v(_vm._s(_vm.p)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }